import { render, staticRenderFns } from "./WpBottomMid.vue?vue&type=template&id=40d613fc&"
import script from "./WpBottomMid.vue?vue&type=script&lang=js&"
export * from "./WpBottomMid.vue?vue&type=script&lang=js&"
import style0 from "./WpBottomMid.vue?vue&type=style&index=0&id=40d613fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports